import { getEntity, getEntities } from './_utils'

export const getAdmins = getEntities('admins')
export const getAdmin = (state, { id }) => getEntity('admins')(state, { id })

// export const getAdminsList = (state) => getAdminsOrder(state).map((id) => getAdmin(state, { id }))
